import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { baseHref } from "service/api";

type ListResponse = {
  countries: {
    value: string;
    label: string;
  }[];
  result: boolean;
};

type ExcludedCountryCodesResponse = {
  excludedCountryCodes: string[];
  result: boolean;
};

export const countriesApi = createApi({
  reducerPath: "countriesApi",
  baseQuery: fetchBaseQuery({
    baseUrl: baseHref,
    credentials: "include",
  }),
  endpoints: (builder) => ({
    listCountries: builder.query<ListResponse, { kycProgramId: number }>({
      query: (params) => {
        const queryParams = new URLSearchParams();
        queryParams.append("kyc_program_id", params.kycProgramId.toString());
        return `countries?${queryParams.toString()}`;
      },
    }),
    getExcludedCountryCodes: builder.query<
      ExcludedCountryCodesResponse,
      { kycProgramId: number }
    >({
      query: (params) => {
        const queryParams = new URLSearchParams();
        queryParams.append("kyc_program_id", params.kycProgramId.toString());
        return `excluded-country-codes?${queryParams.toString()}`;
      },
    }),
  }),
});

export const { useListCountriesQuery, useGetExcludedCountryCodesQuery } =
  countriesApi;
